import React from "react"
import PropTypes from "prop-types"
import { Stepper } from "@kit/design/stepper"
import { SIGNALS_STATE } from "pages/signals/constants"

const STEPS = [
  {
    upcoming: "You'll join the queue",
    active: "You're in the queue",
    completed: "You've joined the queue"
  },
  {
    upcoming: "We'll process your subscriber enrichment",
    active: "We're processing your subscriber enrichment",
    completed: "We processed your subscriber enrichment"
  },
  {
    upcoming: "You'll get an email when your data is ready",
    active: "You'll get an email when your data is ready",
    completed: "You'll get an email when your data is ready"
  }
]

const ACTIVE_STEP_BY_STATE = {
  [SIGNALS_STATE.IN_ENRICHMENT_QUEUE]: 1,
  [SIGNALS_STATE.ENRICHING]: 2
}

function getStepState(stepIndex, signalsState) {
  const activeStep = ACTIVE_STEP_BY_STATE[signalsState] ?? 0
  if (stepIndex + 1 < activeStep) return "completed"
  if (stepIndex + 1 === activeStep) return "active"
  return "upcoming"
}

export function SignalsWhatToExpectStepper({ state, className }) {
  // ENABLED is not currently supported. Callers should not render it but including a guard here too.
  if (state === SIGNALS_STATE.ENABLED) return null

  return (
    <Stepper className={className}>
      <Stepper.Heading>What to expect</Stepper.Heading>
      <Stepper.List>
        {STEPS.map((step, i) => {
          const stepState = getStepState(i, state)
          return (
            <Stepper.Item key={step.upcoming} state={stepState}>
              {step[stepState]}
            </Stepper.Item>
          )
        })}
      </Stepper.List>
    </Stepper>
  )
}

SignalsWhatToExpectStepper.propTypes = {
  state: PropTypes.oneOf(Object.values(SIGNALS_STATE)),
  className: PropTypes.string
}
